import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { AppRoutingModule } from "./routes/app-routing.module";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslationModule } from './shared/translation.module';
import { ToastModule } from './shared/toast.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarMobileComponent } from './components/sidebar-mobile/sidebar-mobile.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { PipesModule } from './pipes/pipes.module';
import { SharedModule } from './shared/shared.module';
import { ManageDashboardModule } from './pages/dashboard/manage-dashboard/manage-dashboard.module';
import { AppService } from './services/app.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieModule, CookieService } from 'ngx-cookie';
import { ServiceWorkerModule, } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { AuthService } from './services/auth.service';
import { ApplicationInsightService } from './services/application-insight.service';
import { MarkdownModule } from 'ngx-markdown';
import { SpeechRecognitionService } from './services/speech-recognition.service';
import { SignalRConfig, SignalRService, SignalrWindow } from '../assets/signalr.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/");
}

export function tokenGetter() {
  return localStorage.getItem('token') || '';
}

let signalRConfig = new SignalRConfig();
signalRConfig.hubName = "DispatcherHub";

@NgModule({
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  CookieModule.forRoot(),
  MarkdownModule.forRoot(),
    A11yModule,
    SharedModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ManageDashboardModule,
    ReactiveFormsModule,
    PipesModule,
    TranslationModule,
    ToastModule,
  JwtModule.forRoot({
    config: {
      tokenGetter: tokenGetter,
    }
  }),
  ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    registrationStrategy: 'registerWhenStable:10000'
  }), NavbarComponent,
    SidebarComponent,
    SidebarMobileComponent],

  providers: [AppService,
    CookieService,
    {
      provide: APP_INITIALIZER,
      useFactory: (signalrService: SignalRService) => () => signalrService.start(),
      deps: [SignalRService],
      multi: true,
    },
    { provide: SignalrWindow, useValue: window },
    { provide: 'channel.config', useValue: signalRConfig },

    GoogleAnalyticsService,
    ApplicationInsightService,
    SpeechRecognitionService,
    AuthService,
    SignalRService,
    JwtHelperService,
    provideHttpClient(withInterceptorsFromDi())]
})


export class AppModule {
}
